import React, { useState } from 'react';
import {
  Box,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Avatar,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { motion } from 'motion/react';
import { sectionVariants } from '../../animations/variants';
import JITSidebar from './JITSidebar';
import { hasMinRole, ROLES } from '../../utils/roles';

// Helper function to derive display name from email
const getDisplayNameFromEmail = (email) => {
  if (!email) return 'User';
  const localPart = email.split('@')[0];
  return localPart
    .replace(/[._-]/g, ' ')
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const JITLayout = ({ children, user, pendingCount = 0 }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleMobileToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', minHeight: '100vh' }}>
      {/* Mobile App Bar */}
      {isMobile && (
        <AppBar
          position="sticky"
          elevation={0}
          sx={{
            backgroundColor: '#FFFFFF',
            borderBottom: '1px solid #E5E5E5',
            zIndex: theme.zIndex.appBar,
          }}
        >
          <Toolbar sx={{ justifyContent: 'space-between', minHeight: '64px !important' }}>
            <IconButton
              onClick={handleMobileToggle}
              sx={{ color: '#253E66' }}
              edge="start"
            >
              <MenuIcon />
            </IconButton>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img
                src="https://www.cloudkeeper.com/themes/cloud_theme/images/Cloudkeeper_New.svg"
                alt="CloudKeeper"
                style={{
                  height: '22px',
                  width: 'auto',
                  objectFit: 'contain',
                }}
              />
              <Typography
                variant="caption"
                sx={{
                  color: '#4698D3',
                  fontFamily: 'Metropolis, sans-serif',
                  fontWeight: 600,
                  fontSize: '0.65rem',
                }}
              >
                JIT Access Portal
              </Typography>
            </Box>
            <Avatar
              sx={{
                width: 32,
                height: 32,
                backgroundColor: hasMinRole(user?.role, ROLES.SSO_ADMIN) ? '#7B1FA2' : hasMinRole(user?.role, ROLES.APPROVER) ? '#D64794' : '#4698D3',
                fontFamily: 'Metropolis, sans-serif',
                fontWeight: 600,
                fontSize: '0.8rem',
              }}
            >
              {getDisplayNameFromEmail(user?.email).charAt(0).toUpperCase()}
            </Avatar>
          </Toolbar>
        </AppBar>
      )}

      <JITSidebar
        user={user}
        pendingCount={pendingCount}
        mobileOpen={mobileOpen}
        onMobileToggle={handleMobileToggle}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#F9FBFD',
          minHeight: isMobile ? 'auto' : '100vh',
          overflow: 'auto',
        }}
      >
        <motion.div
          variants={sectionVariants}
          initial="initial"
          animate="animate"
          style={{ flexGrow: 1, padding: '0' }}
        >
        <Box sx={{ flexGrow: 1, p: { xs: 2, sm: 3 } }}>
          {children}
        </Box>
        </motion.div>
      </Box>
    </Box>
  );
};

export default JITLayout;
